import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import {  LoanMonthData} from "@/data/loanData";

export default function CollectionRateChart({ rows }: { rows: LoanMonthData[] }) {
  const chartData = rows.map((d) => ({
    month: d.month.replace(" 2025", " '25").replace(" 2026", " '26"),
    rate: d.collectionRate,
  }));

  return (
    <div className="rounded-lg border border-border bg-card p-5 shadow-sm">
      <h3 className="text-lg font-semibold text-card-foreground mb-1">Collection Rate</h3>
      <p className="text-sm text-muted-foreground mb-4">Percentage collected vs expected</p>

      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220, 13%, 90%)" />
          <XAxis dataKey="month" tick={{ fontSize: 11 }} />
          <YAxis tick={{ fontSize: 11 }} domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
          <Tooltip formatter={(v: number) => `${v}%`} />
          <Line type="monotone" dataKey="rate" stroke="hsl(173, 58%, 39%)" strokeWidth={2} dot={false} name="Rate" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
